import {
	VIEWDOCUMENTS_SEARCHING,
	VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
	VIEWDOCUMENTS_SET_SOURCE_FILTER,
	VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY,
	LOAD_DOCUMENTS_OF_CONCEPT,
	LOAD_CONCEPT_FROM_API,
	GET_TARGET_TERMS_OF_CATEGORY,
	LOAD_SEARCH_FROM_API,
	GET_ALL_DOCUMENTS_REQUEST,
	GET_ALL_DOCUMENTS_REQUEST_SUCCESS,
	GET_ALL_DOCUMENTS_REQUEST_FAILED,
	GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR,
	DOCUMENTS_SET_PRIORITY_REQUEST,
	GET_DOCUMENTS_REQUEST,
	GET_DOCUMENTS_REQUEST_SUCCESS,
	GET_DOCUMENTS_REQUEST_FAILED,
	GET_DOCUMENTS_REQUEST_FAILED_CLEAR,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR,
	UPDATE_METADATA,
	UPDATE_VIEWDOCUMENTS_METADATA,
	SET_EXPAND_GRAPH,
} from "../types"

export const updateDocumentViewDocumentsPriority = (document_id, priority) => ({
	type: VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY,
	payload: { id: document_id, priority: priority },
})

export const setCurrentSourceFilter = (filter) => ({
	type: VIEWDOCUMENTS_SET_SOURCE_FILTER,
	payload: filter,
})

export const setLoader = () => ({
	type: VIEWDOCUMENTS_SEARCHING,
	payload: true,
})

export const requestDocumentsList = (value) => ({
	type: VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
	payload: value,
})

export const loadDocumentsOfConcept = (filtersObject) => ({
	type: LOAD_DOCUMENTS_OF_CONCEPT,
	payload: filtersObject,
})

export const loadConceptFromAPI = (data) => ({
	type: LOAD_CONCEPT_FROM_API,
	payload: data,
})

export const getTargetTermsOfCategory = (categories) => ({
	type: GET_TARGET_TERMS_OF_CATEGORY,
	payload: {
		categories: categories,
	},
})

export const loadSearchFromAPI = (data) => ({
	type: LOAD_SEARCH_FROM_API,
	payload: data,
})

export const getAllDocumentsRequest = (data) => ({
	type: GET_ALL_DOCUMENTS_REQUEST,
	payload: data,
})

export const getAllDocumentsRequestSuccess = (data) => ({
	type: GET_ALL_DOCUMENTS_REQUEST_SUCCESS,
	payload: data,
})

export const getAllDocumentsRequestFailed = (data) => ({
	type: GET_ALL_DOCUMENTS_REQUEST_FAILED,
	payload: data,
})

export const getAllDocumentsRequestFailedClear = (data) => ({
	type: GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR,
})

export const documentSetPriorityRequest = (data) => ({
	type: DOCUMENTS_SET_PRIORITY_REQUEST,
	payload: data,
})

export const getDocumentsRequest = (data) => ({
	type: GET_DOCUMENTS_REQUEST,
	payload: data,
})

export const getDocumentsRequestSuccess = (data) => ({
	type: GET_DOCUMENTS_REQUEST_SUCCESS,
	payload: data,
})

export const getDocumentsRequestFailed = (data) => ({
	type: GET_DOCUMENTS_REQUEST_FAILED,
	payload: data,
})

export const getDocumentsRequestFailedClear = (data) => ({
	type: GET_DOCUMENTS_REQUEST_FAILED_CLEAR,
})

export const getAllDocumentsInBackgroundRequest = (data) => ({
	type: GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST,
	payload: data,
})

export const getAllDocumentsInBackgroundRequestSuccess = (data) => ({
	type: GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS,
	payload: data,
})

export const getAllDocumentsInBackgroundRequestFailed = (data) => ({
	type: GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED,
	payload: data,
})

export const getAllDocumentsInBackgroundRequestFailedClear = (data) => ({
	type: GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR,
})

export const updateMetadata = (data) => ({
	type: UPDATE_METADATA,
	payload: data,
})

//update viewDocument metadata
export const updateViewDocumentMetadata = (data) => ({
	type: UPDATE_VIEWDOCUMENTS_METADATA,
	payload: data,
})

//grpah hide and show
export const setExpandGraph = (data) => ({
	type: SET_EXPAND_GRAPH,
	payload: data,
})
